import React, { useState, useEffect } from 'react';
import Modal from './Modal.tsx';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

interface InactivityModalProps {
  isOpen: boolean;
  onStayActive: () => void;
  onLogout: () => void;
  countdown: number;
}

const InactivityModal: React.FC<InactivityModalProps> = ({ isOpen, onStayActive, onLogout, countdown }) => {
    const [timeLeft, setTimeLeft] = useState(countdown);

    useEffect(() => {
        if (isOpen) {
            setTimeLeft(countdown);
            const timer = setInterval(() => {
                setTimeLeft(prevTime => {
                    if (prevTime <= 1) {
                        clearInterval(timer);
                        return 0;
                    }
                    return prevTime - 1;
                });
            }, 1000);
            return () => clearInterval(timer);
        }
    }, [isOpen, countdown]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4">
          <div className="bg-surface rounded-lg shadow-xl p-6 w-full max-w-md text-center">
            <ExclamationTriangleIcon className="h-12 w-12 text-status-warning mx-auto" />
            <h2 className="text-xl font-bold text-text mt-4">Are you still there?</h2>
            <p className="text-sm text-text-subtle mt-2">
              For your security, you will be logged out due to inactivity in {timeLeft} seconds.
            </p>
             <div className="flex justify-center space-x-4 mt-6">
                <button onClick={onLogout} className="bg-surface py-2 px-4 border border-border rounded-lg shadow-sm text-sm font-medium text-text hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-surface focus:ring-primary-focus">
                    Log Out
                </button>
                <button onClick={onStayActive} className="inline-flex items-center justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-lg text-white bg-primary hover:bg-primary-hover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-surface focus:ring-primary">
                    Stay Signed In
                </button>
            </div>
          </div>
        </div>
    );
};

export default InactivityModal;
